import Ajv, { ErrorObject } from "ajv"
import ajvErrors from "ajv-errors"
import React, { useState } from "react"
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap"
import { useDispatch } from "react-redux"
import { useHistory } from "react-router-dom"
import { AppDispatch } from "../.."
import AlertComponent from "../../components/AlertComponent"
import { LOCALSTORAGE_PROPERTIES } from "../../constant/localstorageProperties"
import { clearAlert, setAlerts } from "../../globalStore/alertStore"
import { login } from "../../globalStore/authStore"
import { authLoginReqSchema } from "../../service/auth/authScheme"
import { TAuthLoginRes } from "../../service/auth/TAuth"
import SyainGridLayoutService from "../../service/master/syainGridLayout/SyainGridLayoutService"
import LogoMark from "../../source/img/logomark.png"
import { ReactComponent as UpdateIcon } from "../../source/img/icons/update_black_24dp.svg"
import { BUILD_TIME_STAMP } from "../../constant/constant"
import { changeTablet } from "../../globalStore/terminalStore"

const Login = () => {
  const history = useHistory()
  const dispatch: AppDispatch = useDispatch()

  const [社員コード, set社員コード] = useState<string>("")
  const [isInvalid社員コード, setIsInvalidユーザーID] = useState<boolean>()
  const [password, setPassword] = useState<string>("")
  const [isInvalidPassword, setIsInvalidPassword] = useState<boolean>()
  const [isLoginError, setIsLoginError] = useState<boolean>(false)
  const [errorMessages, setErrorMessages] = useState<string[]>([])

  const loginClick = async () => {
    dispatch(clearAlert())
    setIsLoginError(false)

    const ajv = new Ajv({ allErrors: true })
    ajvErrors(ajv)

    const validate = ajv.compile(authLoginReqSchema)

    const params = {
      ユーザーコード: 社員コード,
      パスワード: password,
    }
    const validateResult = validate(params)

    if (!validateResult) {
      const errors = validate.errors

      if (errors != null && errors.length > 0) {
        //エラーメッセージのparamsより対象の項目を発見し色変え
        setValidateError(errors)
        setErrorMessages([
          ...errors
            .filter((e) => e.message != null)
            .map((e) => e.message ?? ""),
        ])
      }
      setIsLoginError(true)
      return
    }

    try {
      const res = await dispatch(login(params))
      const loginRes: TAuthLoginRes = res.payload as TAuthLoginRes

      // 社員グリッドレイアウト取得
      if (loginRes) {
        const getLayoutRes = await new SyainGridLayoutService().getList({
          社員ID: loginRes.LoginUserInfo.社員ID,
        })
        getLayoutRes.data.forEach((d) => {
          const gridLayoutKey = `${LOCALSTORAGE_PROPERTIES.PAGE_CONDITION_DATA}_${d.パス}_${d.グリッドコード}`
          const pageSizeKey = `${LOCALSTORAGE_PROPERTIES.GRID_PAGE_SIZE}_${d.パス}_${d.グリッドコード}`
          if (d.ページサイズ) localStorage[pageSizeKey] = d.ページサイズ
          localStorage[gridLayoutKey] = d.レイアウト
        })
      }

      history.push("/top")
    } catch (error) {
      dispatch(setAlerts(error))
      setIsLoginError(true)
    }
  }

  /**
   * エラー
   * @param errors
   */
  const setValidateError = (
    errors: ErrorObject<string, Record<string, any>, unknown>[]
  ) => {
    const instancePaths = errors.map((e) => e.instancePath.replaceAll("/", ""))
    setIsInvalidユーザーID(instancePaths.includes("社員コード"))
    setIsInvalidPassword(instancePaths.includes("パスワード"))
  }

  return (
    <Container className="login-background" fluid>
      <Card className="mx-auto d-flex align-items-center login-form">
        <div>
          <div>
            <img src={LogoMark} alt="" className="login-logomark center" />
            <span className="login-company-text">大川運輸株式会社</span>
          </div>
          <div className="text-center">
            <div className="login-system-text">Kairosシステム</div>
          </div>
        </div>
        <div
          style={{
            marginTop: "20px",
            visibility: isLoginError ? "visible" : "hidden",
          }}
          className="text-danger font-weight-bold">
          <p className="text-center">ログインに失敗しました</p>
          {errorMessages.map((message, i) => (
            <div className="text-center" key={`${message}_${i}`}>
              {message}
            </div>
          ))}
          <div className="text-center">
            <AlertComponent className=""></AlertComponent>
          </div>
        </div>
        <Form className="w-100 mb-4">
          <Container>
            <Row className={"justify-content-center"}>
              <Col xs={10}>
                <Form.Group as={Row}>
                  <Form.Label xs={4} column>
                    社員コード
                  </Form.Label>
                  <Col>
                    <Form.Control
                      className={isInvalid社員コード ? "is-error" : ""}
                      aria-required={true}
                      required
                      value={社員コード}
                      onChange={(e) => set社員コード(e.target.value)}
                      autoFocus={true}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label xs={4} column>
                    パスワード
                  </Form.Label>
                  <Col>
                    <Form.Control
                      className={isInvalidPassword ? "is-error" : ""}
                      aria-required={true}
                      required
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row className={"justify-content-center mt-3"}>
              <Col className="text-center">
                <Button
                  style={{ height: "3rem", width: "10rem" }}
                  variant="primary"
                  onClick={(e) => {
                    e.preventDefault()
                    loginClick()
                  }}
                  type="submit">
                  ログイン
                </Button>
              </Col>
            </Row>
          </Container>
        </Form>
      </Card>
      <div
        onClick={async (e) => {
          e.preventDefault()
          e.stopPropagation()
          window.location.reload()
        }}
        style={{
          position: "absolute",
          bottom: "2rem",
          left: "1rem",
          color: "white",
          fontSize: "1rem",
          padding: "1rem",
        }}>
        ver.{BUILD_TIME_STAMP}
        <br />
        <UpdateIcon fill="white" />
        アプリを更新する
      </div>

      <div
        onClick={async (e) => {
          e.preventDefault()
          e.stopPropagation()
          dispatch(changeTablet())
        }}
        style={{
          position: "absolute",
          bottom: "2rem",
          right: "1rem",
          color: "white",
          backgroundColor: "rgba(0,0,0,0)",
          fontSize: "2rem",
          padding: "0.5rem",
        }}>
        点呼タブレットを表示する
      </div>
      <div className="login-background-color"></div>
      <span className="login-env-name-text">
        {process.env.REACT_APP_ENVIRONMENT_NAME}
      </span>
    </Container>
  )
}

export default Login
